import { LinkOrganica } from './LinkOrganica';

export class LinkOrganicaResponse {
    constructor(
            )
    { }
    public linkParent: LinkOrganica;
    public linkChildren: LinkOrganica[];
    public estado: number = 0; 
}